import React, { useState } from "react";
import { useTranslation } from "react-i18next";
import { useSelector } from "react-redux";
import { Body2, Card, Chip, CollapseExpandSingleIcon, Trigger } from "@activecollab/components";
import classNames from "classnames";
import { useUserApiTokens } from "~/repository";
import { getLoggedUserId } from "~/store/selectors/selector.users";
import ApiTokensList from "./ApiTokensList";

const ApiTokensCard = () => {
  const { t } = useTranslation();
  const [expanded, setExpanded] = useState(false);
  const loggedUserId = useSelector(getLoggedUserId);

  const { data } = useUserApiTokens(loggedUserId);

  return (
    <div className="tw-mb-1">
      <Trigger
        className="tw-w-full"
        data-testid="expand-trigger"
        onClick={() => setExpanded(!expanded)}
      >
        <Card
          className={classNames(
            "tw-min-h-[68px] tw-flex tw-items-center tw-justify-between tw-gap-2 tw-pl-5 tw-pr-4 tw-py-3",
            {
              "tw-rounded-b-none tw-shadow-none": expanded,
            }
          )}
          variant="paper-2"
        >
          <div className="tw-flex tw-flex-col tw-flex-1 tw-truncate tw-pr-3">
            <div className="tw-flex tw-gap-4 tw-items-center">
              <img
                src="/assets/system/images/integrations/api_tokens.png"
                alt="Tokens key"
                width={32}
                height={32}
              />
              <div>
                <Body2
                  className="tw-mb-0.5"
                  weight="bold"
                >
                  {t("API Tokens")}
                </Body2>
                <Body2 color="tertiary">{t("Generate and manage API tokens for secure integrations.")}</Body2>
              </div>
            </div>
          </div>

          {data?.length ? (
            <Chip
              label={data?.length}
              backgroundColor="var(--color-theme-300)"
              typographyProps={{
                variant: "Caption 1",
                weight: "medium",
                color: "secondary",
                align: "center",
              }}
              className="tw-shrink-0 tw-rounded-md tw-min-w-[24px] tw-w-fit"
            />
          ) : null}

          <CollapseExpandSingleIcon
            className={classNames({
              "tw-rotate-180": !expanded,
            })}
          />
        </Card>
      </Trigger>
      {expanded && (
        <ApiTokensList
          data={data}
          userId={loggedUserId}
        />
      )}
    </div>
  );
};

export default ApiTokensCard;
